import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { BorderColors, Borders, Corners, Fonts, Paddings } from '../Label.h'
import {
  QUALITY_BADGE_ICON_HEIGHT,
  qualityBadgeProps,
} from './qualityBadgeProps'

export type IQualityLabelProps = ILabelProps

/**
 * Renders known resolutions (HD/SD/FHD/2K/4K, including Nora `_2K`/`_4K`)
 * as SVG badge icons only — never as text pseudo-labels.
 */
export const QualityLabel = ({
  title = '',
  background,
  borders = Borders.BORDER_20,
  borderColor = BorderColors.TEXT_ICON_SECONDARY,
  padding = Paddings.SIZE_70,
  font = Fonts.FontXs,
  color = COLOR.TEXT_ICON_SECONDARY,
  corners = Corners.CORNERS_5,
  order,
  icon,
  iconSize,
  iconHeight,
  ...rest
}: IQualityLabelProps): JSX.Element => {
  const badge =
    icon != null
      ? { icon, iconSize }
      : typeof title === 'string'
        ? qualityBadgeProps(title)
        : null

  if (badge) {
    return (
      <Label
        title=''
        background={background}
        color={color}
        corners={corners}
        order={order}
        borders={Borders.BORDER_0}
        icon={badge.icon}
        iconSize={badge.iconSize}
        iconHeight={iconHeight ?? QUALITY_BADGE_ICON_HEIGHT}
        {...rest}
      />
    )
  }

  return (
    <Label
      title={title}
      background={background}
      padding={padding}
      font={font}
      color={color}
      corners={corners}
      order={order}
      borders={borders}
      borderColor={borderColor}
      icon={icon}
      iconSize={iconSize}
      iconHeight={iconHeight}
      {...rest}
    />
  )
}
